import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography } from '@mui/material';

interface InfoDialogProps {
  loading?: boolean;
  title?: string;

  closeLabel?: string;

  onClose: () => void;
  children?: React.ReactNode;
  open?: boolean;
  message?: string;
  fullscreen?: boolean;
}

export function InfoDialog(props: InfoDialogProps) {
  const {
    open = true,
    loading = false,
    title = 'Potvrdenie',
    closeLabel = 'OK',
    onClose,
    children,
    fullscreen,
  } = props;
  return (
    <Dialog open={open} fullWidth maxWidth="xs" fullScreen={fullscreen} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {children}
        {props.message && <Typography variant="body1">{props.message}</Typography>}
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={onClose} color="primary" variant="contained">
          {closeLabel}
        </Button>
      </DialogActions>
      {loading && <LinearProgress />}
    </Dialog>
  );
}
